import { styled } from "@mui/material/styles";
import SubscriberGroups from "views/Status/SubscriberGroups/component";
import SubscriberGroupDashboard from "views/Statistics/SubscriberGroupDashboard/component";
import { SubscribersAndDetails } from "../Subscribers/SubscribersAndDetails";
import SubscriberGroupEdit from "views/Status/SubscriberGroupsEdit/component";
import VerifiedSubcriberDetail from "views/Statistics/SubscriberDetail/component";
import ThroughputAndDashboard from "../SubscriberThroughputLive/ThroughputAndDashboard";
import PolicyRateEdit from "views/Config/SubscriberRates/PolicyEdit/PolicyRateEdit";
import { useEffect } from "react";
  
  const DetailsLayer = styled("div")(() => ({
    position: 'absolute',
  }));
  
  export function SubscriberGroupsAndDashboard({ returnView, ipAddress, addr, subsId, dpiEnabled, direction, timePeriod, metric, subscriberGroup, edit, view, use, types, policy, type}){
    const params = { returnView, ipAddress, addr, subsId, dpiEnabled, direction, timePeriod, metric, subscriberGroup, use, types, policy, type};
    const showThroughput = view==='throughput';
    const showPolicyRateEdit = view==='policyRateEdit';
    const shouldCreateDashboard = !!subscriberGroup && view !== 'qoe' && !showThroughput;
    const showSubscribers = (returnView === 'viewSubscriberGroupDashboard' || view==='qoe') && !edit;
    const showEdit = edit;
    const showSubscriberDetail = !subscriberGroup && (!!addr || !!subsId) && returnView !== 'viewSubsDetail';
    const shouldShowDashboard = !showSubscribers && !edit && !showThroughput;
    const shouldHideSubscriberGroups = shouldCreateDashboard || showSubscribers || showSubscriberDetail || showThroughput || showPolicyRateEdit;

    useEffect(() => {
      if(shouldHideSubscriberGroups){
        document.getElementsByTagName('html')[0].scrollTop=0
      }
    }, [shouldHideSubscriberGroups])

    return <>
    <div style={{ opacity: shouldHideSubscriberGroups ? 0:1, height: shouldHideSubscriberGroups?0:'auto', overflow:'auto'}}>
      <SubscriberGroups {...params}/>
    </div>
    {shouldCreateDashboard && 
      <DetailsLayer 
        style={{ display:  shouldShowDashboard ? 'block':'none'}} 
        className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
          <SubscriberGroupDashboard {...params}/>
      </DetailsLayer>
    }
    {showSubscribers && 
      <DetailsLayer 
        className="col-lg-12 col-md-12 col-sm-12 col-xs-12 p-l-0 p-r-0">
        <SubscribersAndDetails {...params}/>
      </DetailsLayer>
    }
    {showEdit && 
      <DetailsLayer 
        className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
        <SubscriberGroupEdit {...params} showReturn={true}/>
      </DetailsLayer>
    }
    {showSubscriberDetail && 
      <DetailsLayer 
        className="col-lg-12 col-md-12 col-sm-12 col-xs-12 p-l-0 p-r-0">
        <VerifiedSubcriberDetail {...params}/>
      </DetailsLayer>
    }
    {showThroughput && 
      <DetailsLayer 
        className="col-lg-12 col-md-12 col-sm-12 col-xs-12 p-l-0 p-r-0">
        <ThroughputAndDashboard {...params} showReturn={true}/>
      </DetailsLayer>
    }
    {showPolicyRateEdit && 
      <DetailsLayer 
        className="col-lg-12 col-md-12 col-sm-12 col-xs-12 p-l-0 p-r-0">
        <PolicyRateEdit {...params} showReturn={true}/>
      </DetailsLayer>
    }
    </>
  }